export const USER_CREATE_MODAL_EVENT = 'canvas-agent:user:create-modal';
export const USER_SECTION_EVENT = 'canvas-agent:user:section';
export const USER_FILTER_EVENT = 'canvas-agent:user:filter';
export const USER_FOCUS_EVENT = 'canvas-agent:user:focus';
export const USER_EDIT_MODAL_EVENT = 'canvas-agent:user:edit-modal';
export const USER_SUSPEND_MODAL_EVENT = 'canvas-agent:user:suspend-modal';
export const USER_DELETE_MODAL_EVENT = 'canvas-agent:user:delete-modal';
